import Viewport from './Viewport';
import type { StudyData, ViewportProps } from './Viewport';

export default Viewport;
export type { StudyData, ViewportProps };
